import * as React from 'react';
import { SVGProps } from 'react';

const SvgPerformanceDiaryOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)" fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.781 5.465H5.406a.476.476 0 0 0-.468.482c0 .267.21.483.468.483h2.375c.26 0 .469-.216.469-.483a.476.476 0 0 0-.469-.482ZM7.781 9.327H5.406a.476.476 0 0 0-.468.483c0 .267.21.483.468.483h2.375c.26 0 .469-.216.469-.483a.476.476 0 0 0-.469-.483ZM6.844 7.396H4.469A.476.476 0 0 0 4 7.879c0 .267.21.483.469.483h2.375c.259 0 .468-.216.468-.483a.476.476 0 0 0-.468-.483ZM19.063 9.81h-2.844V7.88c0-.848-1.007-1.295-1.6-.683l-3.75 3.863a.986.986 0 0 0 0 1.365l2.15 2.214-2.62 2.697a.986.986 0 0 0 0 1.366.918.918 0 0 0 1.326 0l3.282-3.38a.986.986 0 0 0 0-1.365l-2.15-2.215 1.487-1.531v.566c0 .533.42.965.937.965h3.781c.518 0 .938-.432.938-.965 0-.534-.42-.966-.938-.966ZM12.754 4.903a.917.917 0 0 0-1.182.12L8.992 7.68a.986.986 0 0 0 0 1.365.918.918 0 0 0 1.326 0l2.035-2.095.685.508.916-.943c.153-.158.334-.28.532-.376l-1.733-1.235Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.206 13.107a1.93 1.93 0 0 1-.48-.871l-4.951 5.1a.986.986 0 0 0 0 1.365.918.918 0 0 0 1.325 0l4.768-4.911-.662-.683Z"
      />
      <path d="M16.688 6.913c.776 0 1.406-.648 1.406-1.448 0-.8-.63-1.449-1.407-1.449-.776 0-1.406.649-1.406 1.449s.63 1.448 1.406 1.448Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgPerformanceDiaryOutlined;
